module.exports = __webpack_public_path__ + "fonts/c23534a.ttf";